module.exports = __webpack_public_path__ + "static/media/logo_white.de7d710f.svg";